import { cloneDeep, forEach } from 'lodash-es'

export default {
  allVariations: state => state.allVariations,
  getVariationIdsOfGroup: (state) => (groupId) => {
    const group = state.allVariations.find(item => item.variationGroupId === groupId)

    return group.variations.reduce((acc, item) => {
      acc.push(item.variationId)
      return acc
    }, [])
  },
  getVariationIdsOfGroupByVariationId: (state) => (variationId) => {
    const group = state.allVariations.find(item => {
      return item.variations.find(sub => sub.variationId === variationId)
    })

    if (group) {
      return group.variations.reduce((acc, item) => {
        acc.push(item.variationId)
        return acc
      }, [])
    }

    return []
  },
  getOtherVariationIdsOfGroup: (state, getters) => (variationId) => {
    const groupVariationIds = getters.getVariationIdsOfGroupByVariationId(variationId)

    return groupVariationIds.reduce((acc, item) => {
      if (item !== variationId) {
        acc.push(item)
      }
      return acc
    }, [])
  },
  getUniqueProductVariationValueIds (state, getters) {
    const productVariations = cloneDeep(getters.getProductVariationInfoData)
    const uniqueProductVariationValueIds = {}
    forEach(productVariations, (variation) => {
      uniqueProductVariationValueIds[variation.variation_value_id] = true
    })
    return Object.keys(uniqueProductVariationValueIds).map(key => parseInt(key))
  },
  getUsedVariationValuesByGroup (state, getters) {
    const uniqueAttrValueIds = getters.getUniqueProductVariationValueIds

    const selectedFilters = state.allVariations.filter(item => {
      return item.variations.filter(sub => {
        return uniqueAttrValueIds.includes(sub.variationId)
      }).length > 0
    })

    return selectedFilters.map(item => {
      const variations = item.variations.filter(sub => {
        return uniqueAttrValueIds.includes(sub.variationId)
      })

      const returnItem = JSON.parse(JSON.stringify(item))
      returnItem.variations = variations
      return returnItem
    })
  },
  getUsedVariationValuesByGroupMerged (state, getters) {
    const uniqueAttrValueIds = getters.getUniqueProductVariationValueIds

    const selectedFilters = state.allVariations.filter(item => {
      return item.variations.filter(sub => {
        return uniqueAttrValueIds.includes(sub.variationId)
      }).length > 0
    })

    const relatedVariationData = getters.getRelatedVariationData

    const uniqueAttrValueIdsMerged = cloneDeep(uniqueAttrValueIds)
    forEach(relatedVariationData, (product) => {
      forEach(Object.values(product.variations), (value) => {
        uniqueAttrValueIdsMerged.push(value.variation_value_id)
      })
    })

    return selectedFilters.map(item => {
      const variations = item.variations.filter(sub => {
        return uniqueAttrValueIdsMerged.includes(sub.variationId)
      })

      const returnItem = JSON.parse(JSON.stringify(item))
      returnItem.variations = variations
      return returnItem
    })
  },
  variationName: (state) => (variationId) => {
    return state.allVariations.reduce((acc, item) => {
      const variation = item.variations.find(sub => sub.variationId === variationId)
      if (variation) {
        acc = variation.variationName
      }
      return acc
    }, '')
  },
  getRelatedVariationData: state => state.relatedVariationData,
  getVariationsActive: state => state.variationsActive,
  getListingVariationGroupCombos: state => state.listingVariationGroupCombos,
  getDuplicateVariationGroupNamesPerGroup (state, getters) {
    const listingVariationGroupCombos = cloneDeep(getters.getListingVariationGroupCombos)
    const duplicateVariationGroupNamesPerGroup = {}
    forEach(listingVariationGroupCombos, (group) => {
      const groupNames = group.variations.map(item => item.variationName)
      const duplicateNames = groupNames.filter((item, index) => groupNames.indexOf(item) !== index)
      if (duplicateNames.length <= 0) {
        return []
      }
      forEach(duplicateNames, (name) => {
        if (!duplicateVariationGroupNamesPerGroup[group.variationGroupId]) {
          duplicateVariationGroupNamesPerGroup[group.variationGroupId] = []
        }
        duplicateVariationGroupNamesPerGroup[group.variationGroupId].push({
          duplicateName: name.replaceAll(' ', ''),
          duplicateCount: groupNames.filter(item => item === name).length,
          ids: group.variations.filter(item => item.variationName === name).map(item => item.variationId)
        })
      })
    })
    return duplicateVariationGroupNamesPerGroup
  },
  getListingVariationGroupCombosWithoutDuplicateValueNames (state, getters) {
    const duplicateVariationGroupNamesPerGroup = cloneDeep(getters.getDuplicateVariationGroupNamesPerGroup)
    const listingVariationGroupCombos = cloneDeep(getters.getListingVariationGroupCombos)
    forEach(listingVariationGroupCombos, (group) => {
      const duplicateVariationNames = duplicateVariationGroupNamesPerGroup[group.variationGroupId]
      if (!duplicateVariationNames) {
        return []
      }
      forEach(duplicateVariationNames, (variationName) => {
        const variationIds = variationName.ids
        variationIds.shift()
        group.variations = cloneDeep(group.variations.filter((item) => {
          return !variationIds.includes(item.variationId)
        }))
      })
    })
    return listingVariationGroupCombos
  },
  getVariationFilterQueryStringVar: state => state.variationFilterQueryStringVar,
  getActiveVariationFilters: state => state.activeVariationFilters.map(Number),
  getActiveVariationFiltersString (state, getters) {
    if (getters.getActiveVariationFilters.length <= 0) {
      return ''
    }
    return `${getters.getVariationFilterQueryStringVar}[]=${getters.getActiveVariationFilters.join(`&${getters.getVariationFilterQueryStringVar}[]=`)}`
  },
  getVariationRecordsUsed: state => state.variationRecordsUsed,
  getProductVariationInfoData: state => state.productVariationInfoData,
  getVariationMergeDuplicateValuesByName: state => state.variationMergeDuplicateValuesByName
}
